import { FC, useEffect, useRef } from "react";
import styled from "styled-components";
import { useChat } from "../../../hooks/useChat";
import Message from "../Message/Message";

const MessagesWrapper = styled("div")`
  display: flex;
  flex-flow: column;
  height: 100%;
  overflow: auto;
  padding: 0 10px;
`;

const NoMore = styled("span")`
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
  font-weight: 600;
`;

const Messages: FC = () => {
  const messagesRef = useRef<HTMLDivElement>(null);
  const { messages } = useChat();

  const scrollToBottom = () => {
    if (messagesRef && messagesRef.current) {
      messagesRef.current.scrollTo({
        top: messagesRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages.length]);

  return (
    <MessagesWrapper ref={messagesRef}>
      {messages.length > 8 && <NoMore>Nenhuma mensagem restante.</NoMore>}
      {messages.map((message) => (
        <Message key={message._id} message={message} />
      ))}
    </MessagesWrapper>
  );
};

export default Messages;
